import { Datagrid, List, TextField, NumberField, EditButton, Edit, Create, SimpleForm, TextInput, NumberInput, required } from 'react-admin';
import { Stack } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';

const StatList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="number" />
      <TextField source="suffix" />
      <TextField source="label" />
      <NumberField source="sortOrder" label="Order" />
      <EditButton />
    </Datagrid>
  </List>
);

const StatForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 520 }}>
    <Stack direction="row" spacing={2}>
      <TextInput source="number" label="Number (e.g. 50, 100)" validate={required()} />
      <TextInput source="suffix" label="Suffix (e.g. +, %, K)" />
    </Stack>
    <TextInput source="label" label="Label" validate={required()} fullWidth />
    <NumberInput source="sortOrder" label="Sort order" defaultValue={0} />
  </Stack>
);

const StatEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><StatForm /></SimpleForm>
  </Edit>
);

const StatCreate = () => (
  <Create redirect="list">
    <SimpleForm><StatForm /></SimpleForm>
  </Create>
);

export default {
  list: StatList,
  edit: StatEdit,
  create: StatCreate,
  icon: BarChartIcon,
  options: { label: 'Stats' },
};
